import React from 'react';

export default function Title(props: { title: string; onClose(): void }) {
  return (
    <div className="h-[88px] bg-[#fff] rounded-t-[20px] flex !items-center !justify-center relative  border-x-0 border-t-0 border-b-[1px] border-solid border-[#f1f1f1]">
      <div className="font-medium text-[34px] text-[#2a2a2a]">
        {props.title}
      </div>

      <img
        src={require('./close.png')}
        className="w-[44px] h-[44px] absolute right-[32px] top-[22px]"
        onClick={props.onClose}
      />
    </div>
  );
}
